<template>
  <v-card
    flat
    class="pa-0"
    style="flex-basis: 100%;"
    color="transparent"
    :light="light"
    :dark="dark"
  >
    <controls
      v-if="auth.isEditor"
      :mode="mode"
      :dirty="text!=origional"
      :dialog="dialog"
      style="position:absolute; z-index:9; top: -30px;"
      @change="setMode"
      @save="saveContent"
      @dialogEdit="showDialog=true"
    />
    <editor
      v-model="text"
      :mode="dialog ? 'viewer' : mode"
      :render-config="renderConfig"
    />
    <dialog-editor
      v-if="dialog && auth.isEditor"
      :show="dialog && showDialog"
      :name="name"
      @close="showDialog=false"
      @fetch="fetch"
    />
  </v-card>
</template>
<script>
import { Editor } from "@navanjr/vuetify-markdown-editor";
import DialogEditor from './Dialog.vue';
import Controls from './Controls.vue';

export default {
  components: {
    Editor, Controls, DialogEditor
  },
  props: {
    name: {
      type: String,
      default: null
    },
    dialog: {
      type: Boolean
    },
    light: {type: Boolean},
    dark: {type: Boolean},
    renderConfig: {
      type: Object,
      default: ()=>{return {}}
    },
  },
 
  data(){
    return {
      mode: "viewer",
      text: "",
      origional: "",
      showDialog: false
    }
  },
  watch: {
    name() {
      this.fetch()
    }
  },
  mounted(){
    this.fetch()
  },
  methods: {
    setMode(v){
      this.mode = v
      this.showDialog = !!(v != 'viewer')
    },
    async fetch(){
      this.text = this.origional = await this.api.get(`/shop/content/${this.name}`)
    },
    async saveContent(){
      let save = await this.api.post(`/shop/content/${this.name}`, {text: this.text})
      if(save){
        this.origional = this.text
      }
    }
  }
};
</script>

<style>
h1, h2, h3 {
  margin-bottom: 20px;
}
</style>